// extracted by mini-css-extract-plugin
export default {"switchLabel":"h7Sf5B","switchButton":"lBOMJH","active":"yoE1wW","disabled":"OpCEWz"};